<template>
    <div>
        <!-- SECTION LABEL -->
        <div id="pricing"></div>
        <!-- PRICING -->
        <div class="pricing-section">
            <div class="pricing-section-left-bg-graphics">
                <img src="assets/images/pricing-section-left-bg.png">
            </div>
            <div class="pricing-section-right-bg-graphics">
                <img src="assets/images/pricing-section-right-bg.png">
            </div>
            <div class="container pricing-container">
                <div class="pricing-title">
                    <h2>Prijzen</h2>
                    <p>
                        Start nu de eerste drie maanden gratis met de Family Portal. Het opzetten van een nieuwe tool en aftoetsen of deze bij uw voorziening past kan kostenloos en zonder verplichtingen!
                    </p>
                </div>
                <!-- PRICE PLANS -->
                <div class="pricing-plan-cards-section">
                    <!-- <div class="col-lg-4 col-md-8 col-xs-10 pricing-card-section">
                        <div class="pricing-card">
                            <p class="pricing-rate">0 €</p>
                            <p class="pricing-period">Familie</p>
                            <p class="pricing-text">Deel momenten!</p>
                            <div class="pricing-all-plan-features-section basic-plan-features-section">
                                <ul>
                                    <li>Nodig Familie uit</li>
                                    <li>Gratis Foto Album (PDF)</li>
                                    <li>In-app aankopen</li>
                                    <li>Ondersteuning</li>
                                </ul>
                            </div>
                            <a class="nav-link learn-more-btn" @click="openFormFamily" href="#starthere">Start nu</a>
                        </div>
                    </div> -->

                    <div class="col-lg-6 col-md-8 col-xs-10 pricing-card-section">
                        <div class="pricing-card">
                            <p class="pricing-rate">€ 99</p>
                            <p class="pricing-period">Voorziening</p>
                            <p class="pricing-text">Voor al uw bewoners!</p>
                            <div class="pricing-all-plan-features-section medium-plan-features-section">
                                <ul>
                                    <li>Medewerkers & Familie</li>
                                    <li>Gratis Foto Album (PDF)</li>
                                    <li>Activiteiten, nieuws, ...</li>
                                    <li>Ondersteuning</li>
                                </ul>
                            </div>
                            <a class="nav-link learn-more-btn" @click="openFormCareFacility" href="#starthere">Start nu</a>
                        </div>
                    </div>
                    
                    <div class="col-lg-6 col-md-8 col-xs-10 pricing-card-section">
                        <div class="pricing-card">
                            <p class="pricing-rate">€ 149</p>
                            <p class="pricing-period">Voorziening +</p>
                            <p class="pricing-text">Integreer met bestaande softwarepakketten</p>
                            <div class="pricing-all-plan-features-section advance-plan-features-section">
                                <ul>
                                    <li>Pakket 'Voorziening'</li>
                                    <li>+ Integreer met Televisie</li>
                                    <li>+ Link Zorgsoftware</li>
                                    <li>+ Link Op maat</li>
                                </ul>
                            </div>
                            <a class="nav-link learn-more-btn" @click="openFormCareFacility" href="#starthere">Start nu</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>	
    </div>
</template>

<script>
export default {
    methods: {
        openFormFamily() {
            this.$emit('open-form-family')
        },
        openFormCareFacility() {
            this.$emit('open-form-care-facility')
        }
    }

}
</script>

<style>

</style>